export default {
  typePayments: [],
  typePayment: {}
}
